import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Form, Input, Modal, Switch } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { axiosErrorHandler } from "../../../../../swzutils";
import CustomerGroupResource from "../api/CustomerGroupResource";
const CustomerGroupUpdateModal = ({ open, tenantId, customerGroup, onCancel, onSave }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (open) {
            form.setFieldsValue({
                "name": customerGroup?.name,
                "active": customerGroup?.active ?? true
            });
        }
    }, [open]);
    const onFinish = (formValues) => {
        setLoading(true);
        const request = {
            tenantId,
            version: customerGroup?.version,
            name: formValues.name,
            active: formValues.active
        };
        if (customerGroup) {
            CustomerGroupResource.update(customerGroup.id, request, onSave, axiosErrorHandler, () => setLoading(false));
        }
        else {
            CustomerGroupResource.create(request, onSave, axiosErrorHandler, () => setLoading(false));
        }
    };
    return (_jsx(Modal, { title: customerGroup?.id ? "Edit customer group" : "Create new customer group", open: open, confirmLoading: loading, onOk: form.submit, onCancel: onCancel, destroyOnHidden: true, children: _jsxs(Form, { layout: "vertical", form: form, onFinish: onFinish, children: [_jsx(Form.Item, { name: "name", label: "Name", rules: [
                        { required: true, message: 'Customer Group Name is required' },
                        { max: 100, message: 'Please limit to 100 characters.' }
                    ], children: _jsx(Input, { maxLength: 100 }) }), _jsx(Form.Item, { name: "active", label: "Active", children: _jsx(Switch, { checkedChildren: _jsx(CheckOutlined, {}), unCheckedChildren: _jsx(CloseOutlined, {}) }) })] }) }));
};
export default CustomerGroupUpdateModal;
